import * as React from "react";
import { TTagModule } from "../../../../services/playground";
import { MProductTagBox, MProductTagWrap, MProductTagtab } from "./styles";
import throttle from "utils/throttle";

const activeTabStyle = (lightColor: string = "#fff", backgroundColor: string = "#ff5a00") => {
	return {
		color: lightColor,
		backgroundColor,
	};
};
const defaultTabStyle = (color: string = "#333") => {
	return {
		color,
	};
};

interface MProductTagProps {
	/** 页面激活的商品tab, 不为空时页面定位到它 格式=foolrId|tabName(比如: floor_pos_1600675088222|🌈%20Gaming%20Accessories) */
	activeTab?: string;
	tagGroup: TTagModule[];
	canScrollFixed: boolean;
	activeTabIndex?: number;
	stickToTop: number;
	clientElement: React.RefObject<HTMLDivElement>;
	onClick: (poolId: string, index: number, fixed?: boolean) => void;
	ChildrenElement?: JSX.Element;
}

function MProductTag(props: MProductTagProps) {
	const { tagGroup, stickToTop = 0 } = props;
	const [activeTab, setActiveTab] = React.useState(props.activeTab);
	const [activeIndex, setActiveIndex] = React.useState(props.activeTabIndex);
	const [isFixed, setTabPostition] = React.useState<boolean>(false);

	React.useEffect(() => {
		if (props.canScrollFixed) {
			window.addEventListener("scroll", throttle(onScroll, 30));
		}
		return () => {
			window.removeEventListener("scroll", onScroll);
		};
	}, []);

	const tabClick = (item: TTagModule, index: number) => {
		setActiveTab(item.id);
		setActiveIndex(index);
		props.onClick(item.id, index, isFixed);
	};
	const onScroll = (event: Event) => {
		const target = event.target as Document;
		const scrollTop =
			target?.documentElement?.scrollTop || window.scrollY || window.pageYOffset;

		const clientElement = props.clientElement?.current;

		if (!clientElement) {
			return;
		}
		const currentElementRect = clientElement?.getBoundingClientRect();
		const condition =
			scrollTop >= clientElement?.offsetTop - props.stickToTop &&
			scrollTop < clientElement?.offsetTop + currentElementRect?.height;
		if (condition) {
			setTabPostition(true);
		} else {
			setTabPostition(false);
		}
	};

	const nextActiveTab = activeTab || props.tagGroup[0]?.id || "";
	return (
		<MProductTagWrap>
			<MProductTagBox
				style={{ backgroundColor: tagGroup[0].bgColor || "#fff" }}
				isFixed={isFixed}
				scrollTop={stickToTop}
			>
				{tagGroup.map((item, index) => (
					<MProductTagtab
						key={item.positionId}
						data-key={item.positionId}
						onClick={() => tabClick(item, index)}
						style={getListStyle(item, nextActiveTab, activeIndex)}
					>
						{item.text.content}
					</MProductTagtab>
				))}
			</MProductTagBox>
		</MProductTagWrap>
	);
}

export default MProductTag;

function getListStyle(item: TTagModule, nextActiveTab: string = "", activeTabIndex: number = 0) {
	let isAcitve = item.id === nextActiveTab;
	if (activeTabIndex) {
		isAcitve = item.positionId === `${nextActiveTab}|${activeTabIndex}`;
	}

	return isAcitve
		? activeTabStyle(item.text.lightColor, item.focusBgColor)
		: defaultTabStyle(item.text.color);
}
